
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SingleTableModel } from '../models/singleTableModel';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class ApiClientsService {

  pageData: any = [];
  constructor(private http: HttpClient, private authService: AuthService) {
  }

  headers = {
    'Authorization': this.authService.Authorization$.value,
    //'LoggedInUserAccessKey': this.authService.AccessDetails$.value.AccessKey
  };
  httpOptions = {
    headers: this.headers
  };

  setheader() {
    this.headers.Authorization = this.authService.Authorization$.value;
    //this.headers.LoggedInUserAccessKey = this.authService.AccessDetails$.value.AccessKey;
    this.httpOptions.headers = this.headers;
  }

  getAllClients(): Observable<any> {
    this.setheader();
    return this.http.get(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/getAllApiClients', { 'headers': this.headers });
  }

  getClientsForUser(): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("methodId", 'getClientsForUser')
      .set("userId", this.authService.AccessDetails$.value.UserId)
      .set("userAccessKey", this.authService.AccessDetails$.value.AccessKey);
    return this.http.get(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value), { 'params': params, 'headers': this.headers });
  }

  getAllClientsWithLimit(accessKey: string, limit: number, lekClientId: string, lekAccessAssociation: string): Observable<any> {
    this.setheader();
    var clients = {};
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    var params = new HttpParams()
      .set("limit", limit)
      .set("lekClientId", lekClientId)
      .set("lekAccessAssociation", lekAccessAssociation)
      .set("methodId", 'getAllClientsWithLimit');

    return this.http.get(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/getAllApiClients', { 'params': params, 'headers': this.headers });
  }

  getClient(clientId: string): Observable<any> {
    this.setheader();
    var params = new HttpParams()
     .set("id", clientId)
    return this.http.get(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/getApiClient', { 'params': params, 'headers': this.headers });
  }

  createClient(client: SingleTableModel): Observable<any> {
    this.setheader();
    client.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.post(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/addApiClient', client, this.httpOptions);
  }

  updateClient(client: SingleTableModel): Observable<any> {
    this.setheader();
    client.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.put(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/updateApiClient', client, this.httpOptions);
  }

  disableClient(client: SingleTableModel): Observable<any> {
    this.setheader();
    client.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.put(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/updateIsActive', client, this.httpOptions);
  }

  deleteClient(clientId: string, clientAccessKey: string): Observable<any> {
    this.setheader();
    //var params = new HttpParams()
    //  .set("clientAccessKey", clientAccessKey)
    //  .set("clientId", clientId);
    let params = {
      accessKey: clientAccessKey,
      id: clientId
    };
    return this.http.delete(environment.apiClientsURL.replace('#hostname#', this.authService.hostName$.value) + '/deleteApiClient', { 'body': params, 'headers': this.headers });
  }
  
}

